module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.tariffspanel.transaction_fee')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group--three-columns"
  }, [_c('ul', _vm._l((_vm.companyTariffs), function(item, index) {
    return _c('li', [_c('div', {
      staticClass: "form-row"
    }, [_c('p', {
      staticClass: "linc-text"
    }, [_vm._v(_vm._s(item.company) + ":")]), _vm._v(" "), _c('el-input', {
      staticClass: "linc-tariff-input",
      attrs: {
        "type": "number",
        "min": "0",
        "disabled": !_vm.overridden
      },
      on: {
        "change": function($event) {
          _vm.updateSettings()
        }
      },
      model: {
        value: (_vm.companyTariffs[index].transactionTariff),
        callback: function($$v) {
          _vm.$set(_vm.companyTariffs[index], "transactionTariff", $$v)
        },
        expression: "companyTariffs[index].transactionTariff"
      }
    })], 1)])
  }), 0)]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.tariffspanel.value_fee')))]), _vm._v(" "), _c('el-table', {
    staticClass: "inventoryTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companyTariffs
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.company))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '0.05',
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.valueTariffs[0].tariff),
            callback: function($$v) {
              _vm.$set(scope.row.valueTariffs[0], "tariff", $$v)
            },
            expression: "scope.row.valueTariffs[0].tariff"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '0.10',
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.valueTariffs[1].tariff),
            callback: function($$v) {
              _vm.$set(scope.row.valueTariffs[1], "tariff", $$v)
            },
            expression: "scope.row.valueTariffs[1].tariff"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '0.20',
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.valueTariffs[2].tariff),
            callback: function($$v) {
              _vm.$set(scope.row.valueTariffs[2], "tariff", $$v)
            },
            expression: "scope.row.valueTariffs[2].tariff"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '0.50',
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.valueTariffs[3].tariff),
            callback: function($$v) {
              _vm.$set(scope.row.valueTariffs[3], "tariff", $$v)
            },
            expression: "scope.row.valueTariffs[3].tariff"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '1.00',
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.valueTariffs[4].tariff),
            callback: function($$v) {
              _vm.$set(scope.row.valueTariffs[4], "tariff", $$v)
            },
            expression: "scope.row.valueTariffs[4].tariff"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '2.00',
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.valueTariffs[5].tariff),
            callback: function($$v) {
              _vm.$set(scope.row.valueTariffs[5], "tariff", $$v)
            },
            expression: "scope.row.valueTariffs[5].tariff"
          }
        })], 1)]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-294aa0c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dq-ui/packages/tariffspanel/src/tariffspanel.vue
// module id = 491
// module chunks = 36